<template>
  <card-background class="form-background__wrapper">
    <div class="form-heading__wrapper">
      <heading-size-h2>Сотрудничество с Казатель</heading-size-h2>
      <paragraph-size-medium :textColor="'var(--text-black)'">
        {{ selectedParagraphText }}
      </paragraph-size-medium>
    </div>
    <card-background>
      <form class="form" @submit.prevent="handleSubmit">
        <heading-size-h3>Форма обратной связи</heading-size-h3>
        <div class="form__wrapper">
          <select-component label="Тип сотрудничества" v-model:value="selectedOption">
            <option
              v-for="option in options"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select-component>
          <div class="form__input-group">
            <div class="form__input-column">
              <input-component
                v-model:value="formData.firstName" 
                label="Ваше имя"
                placeholder="Иван" 
                required="true"
              />
              <input-component
                v-model:value="formData.lastName"
                label="Ваша фамилия"
                placeholder="Иванов"
              />
            </div>
            <div class="form__input-column">
              <input-component
                v-model:value="formData.email"
                label="Ваша почта"
                placeholder="email@gmail.com"
                type="email"
                required="true"
              />
              <input-component
                v-model:value="formData.phone"
                label="Ваш телефон"
                placeholder="+7 (999) 999-99-99"
                type="tel"
                required="true"
              />
            </div>
          </div>
          <text-area-component
            v-model:value="formData.request"
            placeholder="Укажите причину обращения, ссылки на контент и всё, что посчитаете нужным"
          />
          <button-primary type="submit" :disabled="isSubmitDisabled">
            {{ requestSending ? 'Отправка...' : 'Отправить' }}
          </button-primary>
        </div>
      </form>
    </card-background>
    <kaz-notification
      :visibility="showNotification"
      :mode="'toast'"
      :appearance="isError ? 'error' : 'success'"
      :label="deriveNotificationLabel"
      :actionsNeeded="false"
      :descriptionNeeded="isError"
      :description="isError ? 'При отправке обращения произошла ошибка. Попробуйте повторить запрос позже.' : ''"
      :closeNeeded="false"
    />
  </card-background>
</template>

<script>
import CardBackground from '@/components/UI/card/CardBackground.vue';
import HeadingSizeH2 from '@/components/UI/texts/headings/HeadingSizeH2.vue';
import HeadingSizeH3 from '@/components/UI/texts/headings/HeadingSizeH3.vue';
import ParagraphSizeMedium from '@/components/UI/texts/paragraphs/ParagraphSizeMedium.vue';
import ButtonPrimary from '@/components/UI/buttons/ButtonPrimary.vue';
import LabelText from '@/components/UI/texts/labels/LabelText.vue'
import InputComponent from '@/components/UI/inputs/InputComponent.vue';
import SelectComponent from '@/components/UI/inputs/SelectComponent.vue';
import TextAreaComponent from '@/components/UI/inputs/TextAreaComponent.vue';
import KazNotification from '@/components/KazUI/molecules/notification';

import { MailsSenderClient } from '@/generated/mailsender/mailsender_grpc_web_pb.js';
import { fetchMethodData } from '@/utils/loaders.js';


const mailSender = new MailsSenderClient(process.env.VUE_APP_REGISTRATION_SERVICE_URL, null, null);


export default {
  name: 'cooperation',

  components: {
    CardBackground,
    HeadingSizeH2,
    ParagraphSizeMedium,
    HeadingSizeH3,
    ButtonPrimary,
    LabelText,
    InputComponent,
    SelectComponent,
    TextAreaComponent,
    KazNotification,
  },

  data() {
    return {
      selectedOption: this.$route.params.option || '',
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        request: "",
      },
      fromDataPrev: '',
      requestSending: false,
      showNotification: false,
      isError: false,
    }
  },

  computed: {
    options() {
      return [
        { value: 'schools', label: 'Школам' },
        { value: 'libraries', label: 'Библиотекам' },
        { value: 'selfEmployed', label: 'Самозанятым' },
        { value: 'organizations', label: 'Юридическим лицам' },
        { value: 'entrepreneurs', label: 'Индивидуальным предпринимателям' },
        { value: 'partners', label: 'Партнёрам' },
        { value: 'publishers', label: 'Издательствам' },
        { value: 'rightholders', label: 'Правообладателям' },
        { value: 'moderator', label: 'Связь с модератором' },
      ];
    },
    selectedParagraphText() {
      const textMappings = {
        schools: 'Если Вы представитель образовательного учреждения (школа) и хотите на договорных условиях размещать / использовать контент (текст, видео, аудио уроков и решений) просим связаться с нами через форму сотрудничества.',
        libraries: 'Если Вы представитель библиотеки и хотите на договорных условиях размещать / использовать контент (текст, видео, аудио уроков и решений) просим связаться с нами через форму сотрудничества.',
        selfEmployed: 'Если Вы самозанятый и хотите на договорных условиях размещать / использовать контент (текст, видео, аудио уроков и решений) просим связаться с нами через форму сотрудничества.',
        organizations: 'Если Вы представитель юридического лица и хотите на договорных условиях размещать / использовать контент (текст, видео, аудио уроков и решений) просим связаться с нами через форму сотрудничества.',
        entrepreneurs: 'Если Вы индивидуальный предприниматель и хотите на договорных условиях размещать / использовать контент (текст, видео, аудио уроков и решений) просим связаться с нами через форму сотрудничества.',
        partners: 'Если Вы хотите сотрудничать с информационным порталом Kazatel в части размещения информации или ее использования на сайте kazatel.su, просим связаться с нами через форму сотрудничества.',
        publishers: 'Если Вы владеете исключительными правами на образовательный контент (учебники, решебники и прочее) и готовы на договорных условиях размещать контент на нашем сайте kazatel.su, просим заполнить форму ниже для обсуждения форм сотрудничества.',
        rightholders: 'Если Вы считаете, что размещенный на нашем сайте материал нарушает по каким-либо причинам Ваши права, просим, незамедлительно заполнить форму ниже. Для рассмотрения вашего обращения нам необходима ссылка на опубликованный материал, а также документы, подтверждающие, что данный материал принадлежит вам. Мы рассмотрим Ваше обращение в течении трех рабочих дней.',
        moderator: 'Если Вы считаете что, что размещенный на нашем сайте материал не корректен или требует каких-то изменений, просим, незамедлительно заполнить форму ниже. Для рассмотрения вашего обращения нам необходима ссылка на опубликованный материал, а также ваше мнение, о некорректности материала или работы  сайта. Мы рассмотрим Ваше обращение в течении трех рабочих дней.',
      };
      return textMappings[this.selectedOption] || '';
    },
    isSubmitDisabled() {
      return (
        !this.selectedOption ||
        !this.formData.firstName ||
        !this.formData.email ||
        !this.formData.phone ||
        JSON.stringify(this.formData) === this.fromDataPrev ||
        this.requestSending
      );
    },
    deriveNotificationLabel() {
      var label = 'Обращение отправлено';
      if (this.isError) {
        label = 'Что-то пошло не так';
      }
      return label;
    }
  },

  methods: {
    getSelectedOptionLabel() {
      const option = this.options.find(opt => opt.value === this.selectedOption);
      return option ? option.label : '';
    },
    async handleSubmit() {
      try {
        this.requestSending = true;
        this.showNotification = false;
        const requestSendMail = new proto.kazatel.mailsender.Email();
        requestSendMail.setEmail('info@kazatel.su');
        requestSendMail.setSubject('Запрос на сотрудничество');
        const selectedOptionLabel = this.getSelectedOptionLabel();
        requestSendMail.setText(selectedOptionLabel + ': '
          + '\n\nВаша почта: ' + this.formData.email
          + '\n\nВаше имя: ' + this.formData.firstName
          + '\n\nВаша фамилия: ' + this.formData.lastName
          + '\n\nВаш телефон: ' + this.formData.phone
          + '\n\nТекст обращения: ' + this.formData.request
        );
        // console.log(requestSendMail.toObject());
        mailSender.sendMail(requestSendMail, null, this.resultHandlerSend);
        await fetchMethodData(
          mailSender, 
          'sendMail', 
          { request: requestSendMail }
        );
        this.isError = false;
      } catch (e) {
        this.isError = true;
        this.resultHandlerSend(e);
      } finally {
        this.fromDataPrev = JSON.stringify(this.formData);
        this.requestSending = false;
        this.showNotification = true;
        setTimeout(() => { this.showNotification = false; }, 5000);
      }
    },
    resultHandlerSend(err) {
      if (err) {
        let errMsg = null;
        let isAlert = false;
        switch (err.code) {
          case 2:
            errMsg = 'Сервис недоступен\n' + err.message;
            isAlert = true;
            break;
          case 14:
            errMsg = 'Сервис отправки электронных писем недоступен\n' + err.message;
            isAlert = true;
            break;
          default:
            errMsg = `Code: ${err.code}\n message: ${err.message}`;
          //isAlert = true;
        }
        console.error('SEND MAIL:', errMsg);
      }
    }
  }
}
</script>

<style scoped>
.form-background__wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-heading__wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form__wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form__input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 452px;
}

.form__input-group {
  display: flex;
  flex-direction: row;
  gap: 24px;
}

.form__input-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

option {
  color: var(--text-black);
  font-size: 16px;
  font-weight: 500;
  line-height: 100%;
}
</style>